import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createABE_10_40Submittal, updateABE_10_40Quotation } from 'src/_helpers/api';

const name = 'abe-10-40Submittals';

const initialState = {
  abe_10_40Submittals: [],
  error: null,
};

// Ajouter un ABE-10-40 Submittal
const addABE_10_40SubmittalAsync = createAsyncThunk(`${name}/add-abe-10-40-submittal`, async (submittalData, { rejectWithValue }) => {
  try {
    const response = await createABE_10_40Submittal(submittalData);
    //console.log('🚀 ~ API response received:', response);
    return response;
  } catch (error) {
    //console.error('🚀 ~ Error occurred in addSubmittalAsync:', error);
    return rejectWithValue(error.response ? error.response.data : 'Unknown error');
  }
});

const updateABE_10_40SubmittalAsync = createAsyncThunk(`${name}/update-abe-10-40-submittal`, async (submittalData) => {
//  console.log('🚀 ~ submittalData:', submittalData)
  return await updateABE_10_40Quotation(submittalData)
})

const abe_10_40SubmittalSlice = createSlice({
  name,
  initialState,
  reducers: {
    resetState: (state) => {
      state.abe_10_40Submittals = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addABE_10_40SubmittalAsync.pending, (state) => {
        state.error = null;
      })
      .addCase(addABE_10_40SubmittalAsync.fulfilled, (state, action) => {
        state.abe_10_40Submittals.push(action.payload);
      })
      .addCase(addABE_10_40SubmittalAsync.rejected, (state, action) => {
        state.error = action.error;
      })
      .addCase(updateABE_10_40SubmittalAsync.pending, (state) => {
        state.error = null;
      })
      .addCase(updateABE_10_40SubmittalAsync.fulfilled, (state, action) => {
        const index = state.abe_10_40Submittals.findIndex(s => s.id === action.payload.id);
        if (index !== -1) state.abe_10_40Submittals[index] = action.payload;
      })
      .addCase(updateABE_10_40SubmittalAsync.rejected, (state, action) => {
        state.error = action.error;
      });
  },
});

export const abe_10_40SubmittalActions = {
  ...abe_10_40SubmittalSlice.actions,
  addABE_10_40SubmittalAsync,
  updateABE_10_40SubmittalAsync,
};

export const abe_10_40SubmittalsReducer = abe_10_40SubmittalSlice.reducer;
